// TODO: later, during stockReceipt refactoring. Check if it is used.
/** Helps converting a warehouse cell into a *string* cell identifier. */
export const getStockPlaceIdentifier = ({ sectorName, sectorY, sectorX, }) => `${sectorName}-${sectorY}-${sectorX}`;
